<template>
  <div>
    <h2 class="step-name">Review NSAIDS</h2>

    <div class="step-section">
      <h3>Annual NSAIDS</h3>
      <bar :chart-data="chartDataNsaidsSeason" :options="chartOptions" ></bar>
    </div>

    <div class="step-section">
      <h3>Review period to-date NSAIDS</h3>
      <bar :chart-data="chartDataPeriodToDate" :options="chartOptions" ></bar>
    </div>

    <div class="step-section">
      <h3>Top products by total amount used (NSAID in mg/kg by season)</h3>
      <table class="table table-bordered">
        <thead>
          <tr>
            <th>Product</th>
            <th>{{ seasonStartYear -4 }} / {{ seasonStartYear -3 }}</th>
            <th>{{ seasonStartYear -3 }} / {{ seasonStartYear -2 }}</th>
            <th>{{ seasonStartYear -2 }} / {{ seasonStartYear -1 }}</th>
            <th>{{ seasonStartYear -1 }} / {{ seasonStartYear }}</th>
            <th>{{ seasonStartYear }} / {{ seasonStartYear + 1 }}</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(rv, index) in model.CHARTS.nsaid_five_years_products_usage" :key="index">
            <td class="text-left">{{ rv["product"] }}</td>
            <td class="text-left">{{ rv["season_start_4"] }}</td>
            <td class="text-left">{{ rv["season_start_3"] }}</td>
            <td class="text-left">{{ rv["season_start_2"] }}</td>
            <td class="text-left">{{ rv["season_start_1"] }}</td>
            <td class="text-left">{{ rv["season_start"] }}</td>
          </tr>
        </tbody>
      </table>
    </div>

    <div class="step-section">
      <div class="form-group">
        <label for="nsaid_keypoints">Key Points</label>
        <textarea rows="5" cols="50" v-model="model.nsaid_keypoints" class="form-control" :disabled="isReadOnly">
        </textarea>
      </div>

      <div class="form-group">
        <label for="nsaid_actions">Actions</label>
        <textarea rows="5" cols="50" v-model="model.nsaid_actions" class="form-control" :disabled="isReadOnly">
        </textarea>
      </div>
    </div>

  </div>
</template>

<script>
import baseComponent from '@/mixins/base_consult_component'
import Bar from '../../charts/Bar'

export default {
  mixins: [ baseComponent ],
  components: {
    Bar,
  },
  data() {
    return {
      model: {
        nsaid_keypoints: "",
        nsaid_actions: "",
        CHARTS: {
          nsaids_season: [],
          nsaids_period_to_date: [],
          nsaid_five_years_products_usage: [],
        },
      },
    }
  },
  computed: {
    chartOptions: function () {
      return {
        scales: {
          yAxes: [{
            ticks: {
              beginAtZero: true
            },
            scaleLabel: {
              display: true,
              labelString: 'mg/kg'
            }
          }]
        }
      }
    },
    chartDataNsaidsSeason: function () {
      return {
        labels: Array.from(new Set(this.model.CHARTS.nsaids_season.map(row => row['season']))),
        datasets: [
          {
            label: "This Farm",
            backgroundColor:  "#3e95cd",
            data: this.model.CHARTS.nsaids_season.filter(row => row['name'] == 'client').map(row => row['mg_kg_nsaid']),
          },
          {
            label: "Region",
            backgroundColor:  "#c45850",
            data: this.model.CHARTS.nsaids_season.filter(row => row['name'] == 'region').map(row => row['mg_kg_nsaid']),
          },
        ],
      }
    },
    chartDataPeriodToDate: function () {
      return {
        labels: Array.from(new Set(this.model.CHARTS.nsaids_period_to_date.map(row => row['period']))),
        datasets: [
          {
            label: "This Farm",
            backgroundColor:  "#3e95cd",
            data: this.model.CHARTS.nsaids_period_to_date.filter(row => row['name'] == 'client').map(row => row['nsaid_mg_kg']),
          },
          {
            label: "Region",
            backgroundColor:  "#c45850",
            data: this.model.CHARTS.nsaids_period_to_date.filter(row => row['name'] == 'region').map(row => row['nsaid_mg_kg']),
          },
        ],
      }
    },
  },
};
</script>
